import { apiUrl2 } from '../../../../settings'

export const getOnShoreApplicationListForCommissionUrl = () => {
  return apiUrl2 + '/onshore-canada/receipt-issued-applications'
}